import styles from "./generating-spinner.module.css";

interface GeneratingSpinnerProps {
  title?: string;
  subtitle?: string;
}

export function GeneratingSpinner({
  title = "Generating document…",
  subtitle = "This may take a few seconds",
}: GeneratingSpinnerProps) {
  return (
    <div className={styles.container}>
      <div className={styles.spinner} />
      <p className={styles.title}>{title}</p>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  );
}
